import getStatus from './status';
import getError from './error';

export default {
  getStatus,
  getError,
};
